export default {
	styleOverrides: {
		root: {
			'& .MuiSvgIcon-root': { fontSize: '25px' },
			padding: 0,
			height: 'auto',
			borderRadius: '4px',
			color: '#fff',

			boxShadow: '5px 4px 10.8px 0px rgba(166, 203, 245, 0.28)',
		},
	},
};
